import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from 'react';
const CollapsedContext = createContext(false);
CollapsedContext.displayName = 'CollapsedContext';
// eslint-disable-next-line @typescript-eslint/no-empty-function
const SetCollapsedContext = createContext(() => { });
SetCollapsedContext.displayName = 'SetCollapsedContext';
export const useCollapsed = () => [
    useContext(CollapsedContext),
    useContext(SetCollapsedContext),
];
const MobileOpenContext = createContext(false);
MobileOpenContext.displayName = 'MobileOpenContext';
// eslint-disable-next-line @typescript-eslint/no-empty-function
const SetMobileOpenContext = createContext(() => { });
SetMobileOpenContext.displayName = 'SetMobileOpenContext';
export const useMobileOpen = () => [
    useContext(MobileOpenContext),
    useContext(SetMobileOpenContext),
];
const BannerContext = createContext({ showBanner: false, bannerContent: null, setBannerState: () => { } });
BannerContext.displayName = 'BannerContext';
export const useBannerContext = () => useContext(BannerContext);
export const MainLayoutProvider = ({ children, }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [showBanner, setShowBanner] = useState(false);
    const [bannerContent] = useState(false);
    const bannerContextValue = {
        showBanner,
        bannerContent,
        setBannerState: setShowBanner,
    };
    useEffect(() => {
        if (showBanner) {
            setTimeout(() => setShowBanner(false), 5000);
        }
    }, [showBanner]);
    return (_jsx(SetCollapsedContext.Provider, { value: setCollapsed, children: _jsx(SetMobileOpenContext.Provider, { value: setMobileOpen, children: _jsx(MobileOpenContext.Provider, { value: mobileOpen, children: _jsx(CollapsedContext.Provider, { value: collapsed, children: _jsx(BannerContext.Provider, { value: bannerContextValue, children: children }) }) }) }) }));
};
